import { render, staticRenderFns } from "./classAlbum.vue?vue&type=template&id=3bc966c0"
import script from "./classAlbum.vue?vue&type=script&lang=js"
export * from "./classAlbum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports